import { GeneratedAsset, CopyButton } from "./GeneratedAsset";
import VideoPanel from "./VideoPanel";

export default function ClipCard({ clip, frame, onGenerate, video, onVideo, model }) {
  return (
    <div className="card fade-up" data-testid={`clip-${clip.id}`} style={{ display: "grid", gridTemplateColumns: "280px 1fr", gap: 32, padding: 28 }}>
      <div>
        {frame && <GeneratedAsset asset={frame} onGenerate={onGenerate} width={240} />}
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="eyebrow">{clip.time}</div>
        <h3 className="serif" style={{ fontSize: 34, fontWeight: 500, margin: "6px 0 0", lineHeight: 1.1 }}>{clip.title}</h3>
        <div style={{ marginTop: 18, fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--ink-40)" }}>Video prompt</div>
        <p data-testid={`clip-prompt-${clip.id}`} style={{ margin: "8px 0 0", fontSize: 14, lineHeight: 1.65, color: "var(--charcoal)", background: "var(--porcelain)", borderRadius: 14, padding: "16px 18px", border: "1px solid var(--ink-06)" }}>
          {clip.video_prompt}
        </p>
        <div style={{ marginTop: 14, fontSize: 13, color: "var(--ink-60)", lineHeight: 1.5 }}><b style={{ color: "var(--burgundy)" }}>Editor note · </b>{clip.notes}</div>
        <div style={{ paddingTop: 18, display: "flex", gap: 8 }}>
          <CopyButton text={clip.video_prompt} id={clip.id} />
        </div>
        <VideoPanel video={video} frameReady={!!frame?.url} onGenerate={onVideo} model={model} />
      </div>
    </div>
  );
}
